import approve from "./approve"
import secure from "./secure"

export default {
  approve,
  secure
}